import useFetch from 'app/hooks/useFetch'
import {error} from 'app/utils/customToasd'
import {FormikProps} from 'formik'
import {FC, useCallback, useEffect, useMemo, useState} from 'react'
import {callSP} from 'setup/axios/AxiosCallSP'
import ArrayInput from '../../../utils/form/ArrayInput'
import {propsInterfaceFormGroupInput} from '../../../utils/form/FormGroupInput'

const columInput = 2

const StepContract5: FC<StepContract5Props> = ({
  formikProps,
  title,
  subTitle,
  reload,
  data,
  setLoad,
}) => {
  const [selectedCeco, setselectedCeco] = useState([
    {
      text: '',
      value: '',
    },
  ])
  const [servicios, setServicios] = useState<any>([])
  const [reglaCruzadaActived, setreglaCruzadaActived] = useState(false)
  const [arraySelects, setArraySelects] = useState<propsInterfaceFormGroupInput[]>([])

  const handleReglaCruzada = useCallback(() => {
    if (formikProps?.values.ruleCruceRule) {
      formikProps.setFieldValue('reglaSitio', [{text: '', value: ''}])
    }
  }, [formikProps?.values.ruleCruceRule])

 
  const getServices = async (ceco: number) => {
    try {
      const dataServices: any = await callSP('amd_getServiciosByCeco', [
        {text: 'ceco', value: ceco.toString()},
      ])

      if (dataServices.data.status != '200') {
        throw 'Error al consultar servicios!'
      }
      return dataServices.data.result.map((e: any) => ({
        text: e.ser_nombre,
        value: e.ser_codigo.toString(),
      }))
    } catch (e: any) {
      error(e)
    }
  }

  const [arrayInput] = useState<propsInterfaceFormGroupInput[]>([
    {
      id: '1',
      columInput: columInput,
      campo: 'ruleColorDistribution',
      label: 'Distribución homogénea de colores',
      type: 'checkbox',
      className: 'form-check-input',
      isSwitch: true,
    },
    {
      id: '2',
      columInput: columInput,
      campo: 'ruleRecipeRepeat',
      label: 'Repetición Receta',
      type: 'checkbox',
      className: 'form-check-input',
      isSwitch: true,
    },
    {
      id: '3',
      columInput: columInput,
      campo: 'ruleDescriptiveCost',
      label: 'Costo Descriptivo',
      type: 'checkbox',
      className: 'form-check-input',
      isSwitch: true,
    },
    {
      id: '4',
      columInput: columInput,
      campo: 'ruleGarnitureCruce',
      label: 'Cruce Garnitura',
      type: 'checkbox',
      className: 'form-check-input',
      isSwitch: true,
    },
    {
      id: '5',
      columInput: columInput,
      campo: 'ruleNameRepeat',
      label: 'Repetición Nombre',
      type: 'checkbox',
      className: 'form-check-input',
      isSwitch: true,
    },
    {
      id: '6',
      columInput: columInput,
      campo: 'ruleRemoriceEfect',
      label: 'Efecto Meteorizarte',
      type: 'checkbox',
      className: 'form-check-input',
      isSwitch: true,
    },
    {
      id: '7',
      columInput: columInput,
      campo: 'ruleComplexityRecipes',
      label: 'Complejidad Recetas',
      type: 'checkbox',
      className: 'form-check-input',
      isSwitch: true,
    },
    {
      id: '8',
      columInput: columInput,
      campo: 'ruleCookingMethod',
      label: 'Método de Cocción',
      type: 'checkbox',
      className: 'form-check-input',
      isSwitch: true,
    },
    {
      id: '9',
      columInput: 1,
      campo: 'ruleCruceRule',
      label: 'Regla cruzada',
      type: 'checkbox',
      className: 'form-check-input',
      isSwitch: true,
    },

  ])

  const clientConditions = useCallback(
    (reloadService = undefined) => {
      const optionsSitios = data.sitios.map(({cli_nombre, cli_codigo}: any) => ({
        text: cli_nombre,
        value: cli_codigo,
      }))
      const optionsRegimen = data.regimens.map(({reg_nombre, reg_codigo}: any) => ({
        text: reg_nombre,
        value: reg_codigo,
      }))
      setArraySelects([
        {
          id: '9',
          columInput: 2,
          campo: 'reglaSitio',
          label: 'Sitios',
          type: 'autocomplete',
          className: 'form-control form-control-lg input-contract',
          advanceOptions: {
            id: 'structure',
            placeholder: 'Seleccione un cliente',
            multiple: false,
            options: optionsSitios,
          },
          onChange: async (event: any, setFieldValue: any, values: any) => {
            setLoad(true)
            const ceco = values.reglaSitio[0]
            if (ceco?.value && ceco?.value != '') {
              try {
                const getDataSeco = await getServices(ceco.value)
                clientConditions(getDataSeco)
                setLoad(false)
              } catch (e: any) {
                error(e)
                setLoad(false)
              }
            } else {
              setLoad(false)
            }
          },
        },
        {
          id: 'regimen',
          columInput: 2,
          campo: 'reglaRegimen',
          label: 'Regimen',
          type: 'autocomplete',
          className: 'form-control form-control-lg input-contract',
          advanceOptions: {
            id: 'regimen',
            placeholder: 'Seleccione un regimen',
            multiple: false,
            options: optionsRegimen,
          },
        },
        {
          id: 'reglaServicios',
          columInput: 2,
          campo: 'reglaServicios',
          label: 'Servicios',
          type: 'autocomplete',
          className: 'form-control form-control-lg input-contract',
          advanceOptions: {
            id: 'reglaServicios',
            placeholder: 'Seleccione un servicio',
            multiple: false,
            options: reloadService ? reloadService : servicios,
          },
        },
      ])
      if (reloadService) {
        formikProps?.setFieldValue('reglaServicios', [{text: '', value: ''}])
      }
    },
    [arraySelects, formikProps?.values]
  )
  useEffect(() => {
    if (reload) {
      clientConditions()
    }
  }, [reload])
  
  useEffect(() => {
    if (formikProps?.values.ruleCruceRule) {
      formikProps.setFieldValue('reglaSitio', [{text: '', value: ''}])
      formikProps.setFieldValue('reglaRegimen', [{text: '', value: ''}])
    }
  }, [formikProps?.values.ruleCruceRule])
  
  return (
    <div className='w-100'>
      <div className='pb-2 pb-lg-5'>
        <h2 className='text-dark'>{title}</h2>
        <div className='text-gray-400 fw-bold fs-6'>{subTitle}</div>
      </div>
      <hr />
      <ArrayInput classContainer='container-input checkbox-reglas' arrayInput={arrayInput} />
      {formikProps?.values.ruleCruceRule && (
        <ArrayInput classContainer='container-input checkbox-reglas' arrayInput={arraySelects} />
      )}
    </div>
  )
}
interface StepContract5Props {
  title?: string
  subTitle?: string
  onChange?(e: React.ChangeEvent<HTMLInputElement>): void
  formikProps?: FormikProps<any>
  reload: boolean
  data: any
  setLoad: (value: boolean) => void
}
export {StepContract5}
